import React from 'react'
import { ThemeProvider, Text, Link } from '@deseretbook/react-ui'

/**
 * Disclaimer text that's required by Google anywhere we use reCAPTCHA. This is because we hide the
 * reCAPTCHA badge they inject on our site, so this is their compromise.
 *
 * @returns {function} component
 */
const RecaptchaDisclaimer = () => (
  <ThemeProvider>
    <Text>
      This site is protected by reCAPTCHA and the Google{' '}
      <Link href="https://policies.google.com/privacy">Privacy Policy</Link> and{' '}
      <Link href="https://policies.google.com/terms">Terms of Service</Link> apply.
    </Text>
    <style>
      {/* This is what actually hides the reCAPTCHA badge. We'll disable it here so that if we ever forget to include this disclaimer, The badge will still display */}
      {`.grecaptcha-badge { opacity: 0; }`}
    </style>
  </ThemeProvider>
)

/* react-rails requires default export */
/* eslint-disable-next-line import/no-default-export */
export default RecaptchaDisclaimer
